import type Features from "ember-feature-flags";
import ControlTower from "wise-control-tower";

export async function fetchAndSetupFeatureFlags(
  featureService: Features,
  requestManager?,
  blacklistedFlags: string[] = []
) {
  try {
    const data = await fetchFeatureFlagDatas(requestManager);

    // Filter out keys that we don't want
    const filteredData = data.filter(
      ({ key }) => !blacklistedFlags.includes(key)
    );

    // Convert data to be consomable by the Features service
    const flags = Object.fromEntries(
      filteredData.map(({ key, enabled }) => [key, enabled])
    );

    featureService.setup(flags);
  } catch (e) {
    ControlTower.captureException(e);
  }
}

async function fetchFeatureFlagDatas(
  requestManager?
): Promise<{ key: string; enabled: boolean }[]> {
  if (!requestManager) {
    const res = await fetch("/api/v1/feature-flags", {
      headers: {
        "Content-Type": "application/json"
      }
    });
    return (await res.json()).data;
  }

  const res = await requestManager.request({
    url: "/api/v1/feature-flags"
  });
  return res.content.data;
}
